interface LogEntry {
  id: string;
  timestamp: string;
  level: 'info' | 'error' | 'warning' | 'debug';
  category: string;
  message: string;
  data?: any;
}

class DebugLogger {
  private static instance: DebugLogger;
  private logs: LogEntry[] = [];
  private maxLogs = 50;

  private constructor() {
    this.loadLogs();
  }

  static getInstance(): DebugLogger {
    if (!DebugLogger.instance) {
      DebugLogger.instance = new DebugLogger();
    }
    return DebugLogger.instance;
  }

  private loadLogs() {
    try {
      const stored = localStorage.getItem('trade_debug_logs');
      if (stored) {
        this.logs = JSON.parse(stored);
      }
    } catch (e) {
      this.logs = [];
    }
  }

  private saveLogs() {
    try {
      // Keep only last maxLogs entries
      if (this.logs.length > this.maxLogs) {
        this.logs = this.logs.slice(-this.maxLogs);
      }
      localStorage.setItem('trade_debug_logs', JSON.stringify(this.logs));
    } catch (e) {
      // Silently fail
    }
  }

  private log(level: LogEntry['level'], category: string, message: string, data?: any) {
    const entry: LogEntry = {
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString(),
      level,
      category,
      message,
      data
    };

    this.logs.push(entry);
    this.saveLogs();

    // Only log errors to console
    if (level === 'error') {
      console.error(`[${category}] ${message}`, data || '');
    }
  }

  info(category: string, message: string, data?: any) {
    this.log('info', category, message, data);
  }

  error(category: string, message: string, data?: any) {
    this.log('error', category, message, data);
  }

  warning(category: string, message: string, data?: any) {
    this.log('warning', category, message, data);
  }

  debug(category: string, message: string, data?: any) {
    // Skip debug logs to reduce noise
  }

  clear() {
    this.logs = [];
    localStorage.removeItem('trade_debug_logs');
  }

  getLogs(): LogEntry[] {
    return this.logs;
  }
}

export const debugLogger = DebugLogger.getInstance();